import { motion } from "framer-motion";

const easing = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", once = true, immediate = false }) {
  const anim = immediate
    ? { animate: { opacity: 1, y: 0 } }
    : { whileInView: { opacity: 1, y: 0 }, viewport: { once, margin: "-80px" } };
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      {...anim}
      transition={{ duration: 0.8, delay, ease: easing }}
    >
      {children}
    </motion.div>
  );
}

export function Stagger({ children, className = "", stagger = 0.09 }) {
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-60px" }}
      variants={{ show: { transition: { staggerChildren: stagger } } }}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className = "", y = 26 }) {
  return (
    <motion.div
      className={className}
      variants={{
        hidden: { opacity: 0, y },
        show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: easing } },
      }}
    >
      {children}
    </motion.div>
  );
}
